import { CardHeading } from "@/pages/Dashboard/styled";
import * as Styled from "./styled";
import Button from "@/components/shared-ui/Button";
import { useMediaQuery } from "@/hooks/useMatchMedia";

const HubHighlights = () => {
  const isDesktop = useMediaQuery("medium");
  return (
    <Styled.HubHighlights gridColumn="1 / -1">
      <CardHeading>Some highlights from the hub</CardHeading>
      <Styled.CardWrapper>
        <Styled.HighlightCard
          featureBackground={{ full: true, gradient: "light2" }}
          gridColumn="1"
        >
          <div>
            <strong>Process documentation</strong>
            <p>
              Find detailed information on the operational and technical
              processes involved in launching and running a platform on Seccl’s
              technology.
            </p>
          </div>
          <Button
            data-testid="processDocsButton"
            label="See documents"
            variant="tertiary"
            internalLink="/docs"
          />
        </Styled.HighlightCard>
        <Styled.HighlightCard
          featureBackground={{ full: true, gradient: "light2" }}
          gridColumn={isDesktop ? "2" : "1"}
        >
          <div>
            <strong>Product roadmap</strong>
            <p>
              See what we're building now – and what's coming down the track.
            </p>
          </div>
          <Button
            label="Check out the roadmap"
            variant="tertiary"
            internalLink="/product-roadmap"
          />
        </Styled.HighlightCard>
      </Styled.CardWrapper>
    </Styled.HubHighlights>
  );
};

export default HubHighlights;
